import { render, staticRenderFns } from "./SubcontractorTeamPopup.vue?vue&type=template&id=c0071db8"
import script from "./SubcontractorTeamPopup.vue?vue&type=script&lang=ts"
export * from "./SubcontractorTeamPopup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports